<template>
  <div :class="`formstack-iframe`">
    <iframe id="iframe" :src="`${source}?shouldAutoFocus=0`" frameborder="no"/>
  </div>
</template>

<script>
import { iframeResizer } from "iframe-resizer"

export default {
  name: "FormstackForm",
  props: {
    source: {
      type: String,
      default: ''
    }
  },
  mounted() {
    window.addEventListener("resize", this.calculateIframeSize())

    this.$nextTick(() => {
      this.calculateIframeSize()
    });
  },
  methods: {
    calculateIframeSize(id) {
      iframeResizer({ log: false, checkOrigin: false, minWidth: "100%" }, `#iframe`);
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~/assets/scss/_variables.scss';

  .formstack-iframe {
    height: 100%;
    width: 100%;

    iframe {
      width: 1px;
      min-width: 100%;
      max-width: 100%;
    }
  }
</style>
